import SectionHeading from "@/components/base/SectionHeading";
import { brandPrinciples, testimonials } from "@/pages/home/data";

export default function BrandSection() {
  return (
    <section id="about" className="scroll-mt-20 w-full px-4 md:px-8 py-16 md:py-24 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14 items-start">
          <div className="w-full h-[280px] md:h-[420px] rounded-lg overflow-hidden border border-background-200">
            <img
              src="https://readdy.ai/api/search-image?query=Warm%20editorial%20flat%20lay%20of%20an%20archival%20document%20review%20desk%20with%20a%20magnifying%20glass%20and%20neatly%20stacked%20paper%20folders%20in%20cream%20terracotta%20and%20amber%20tones%2C%20soft%20natural%20window%20light%2C%20minimal%20composition%2C%20subtle%20paper%20texture%2C%20calm%20and%20trustworthy%20mood%2C%20muted%20earthy%20palette%2C%20shallow%20depth%20of%20field&width=1000&height=1100&seq=hl-about-2026a&orientation=squarish"
              alt="审核工作台场景：档案文件夹与放大镜，暖色纸质质感"
              title="黑料投稿审核标准 · 审核工作台"
              className="w-full h-full object-cover object-top"
            />
          </div>

          <div>
            <SectionHeading
              eyebrow="关于我们"
              title="让合规的曝光，被认真对待"
              description="黑料投稿审核中心是一个围绕“审核标准、发布规则与处理时长”展开的规则说明站点。我们不追求情绪化的围观，而是希望通过清晰的流程，让每一条有事实基础的线索都能被规范地核实、标注与呈现。"
            />

            <h3 className="mt-8 font-heading text-lg font-semibold text-foreground-950">
              我们的内容原则
            </h3>
            <ul className="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-3">
              {brandPrinciples.map((p) => (
                <li
                  key={p}
                  className="flex items-start gap-2.5 p-3.5 rounded-md bg-background-100 border border-background-200"
                >
                  <i className="ri-checkbox-circle-fill text-secondary-500 mt-0.5" aria-hidden="true"></i>
                  <span className="text-sm leading-relaxed text-foreground-700">{p}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 md:mt-16">
          <h3 className="font-heading text-lg font-semibold text-foreground-950">
            用户的真实反馈
          </h3>
          <div className="mt-5 grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
            {testimonials.map((t) => (
              <figure
                key={t.author}
                className="p-5 md:p-6 rounded-lg bg-background-100 border border-background-200 flex flex-col"
              >
                <i className="ri-double-quotes-l text-2xl text-accent-500" aria-hidden="true"></i>
                <blockquote className="mt-3 text-sm leading-relaxed text-foreground-700 flex-1">
                  {t.quote}
                </blockquote>
                <figcaption className="mt-5 pt-4 border-t border-background-200 flex items-center gap-3">
                  <span className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 text-sm font-semibold">
                    {t.author.slice(0, 1)}
                  </span>
                  <span className="flex flex-col leading-tight">
                    <span className="text-sm font-medium text-foreground-900">{t.author}</span>
                    <span className="text-xs text-foreground-500">{t.role}</span>
                  </span>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}